module.exports = require('./InvoiceGridView');
